module.exports = require('./InvoiceGridView');
